import React from 'react';
import { ReactComponent as HandDrawnUnderline } from 'src/assets/svg/hand-drawn-underline.svg';
import { FormErrorMessage } from 'src/shared/design-system/Input/Error/FormErrorMessage';
import Button, { ButtonType } from 'web-common/src/shared/design-system/components/Button';
import { Icon } from 'web-common/src/shared/design-system/components/Icon';
import { BaseInput } from 'web-common/src/shared/design-system/components/Input';
import { LoginWithEmailProps, useLoginWithEmailForm } from './useLoginWithEmailForm';

const ResetSentCard: React.FC<{ email: string }> = ({ email }) => (
  <div className='mt-[11px] flex flex-col items-center gap-2 rounded-2xl bg-rice px-6 py-[22px] text-center'>
    <Icon name='envelope' size={24} />
    <p className='text-body-400 text-eggplant'>
      A link to reset your password has been sent to <span className='font-bold'>{email}</span>
    </p>
  </div>
);

export const SignUpGateLoginForm: React.FC<LoginWithEmailProps> = (props) => {
  const { email, onEmailChange, loginCTA } = props;
  const {
    password,
    onPasswordChange,
    emailErrorMessage,
    passwordErrorMessage,
    genericErrorMessage,
    resetSentTo,
    requestLoading,
    handleSubmitForm,
    handleForgotPassword,
    handleKeyDown,
  } = useLoginWithEmailForm(props);

  return (
    <form onSubmit={handleSubmitForm} onKeyDown={handleKeyDown} data-cy='login-form'>
      <fieldset className='flex flex-col gap-2 border-none p-0' disabled={requestLoading}>
        <BaseInput
          label='Email'
          name='email'
          value={email}
          onChange={onEmailChange}
          errorMessage={emailErrorMessage}
          hasError={!!emailErrorMessage}
          data-cy='login-email'
          disabled
        />
        <BaseInput
          type='password'
          label='Password'
          name='password'
          value={password}
          onChange={onPasswordChange}
          errorMessage={passwordErrorMessage}
          hasError={!!passwordErrorMessage}
          autoFocus
          data-cy='login-password'
        />
        {genericErrorMessage ? <FormErrorMessage>{genericErrorMessage}</FormErrorMessage> : null}
        <Button
          type='submit'
          buttonType={ButtonType.Primary}
          renderFullWidth
          disabled={requestLoading}
          data-cy='login-button'>
          {loginCTA ?? 'Log in'}
        </Button>
        <div className='mt-2.5 flex justify-center'>
          {/* JA-WEIGHT-SHIM(1218377610766475): caption-500 renders Ja Book where the frame asks for
              Medium, which the map does not declare; the frame's own number is 600 */}
          <button
            type='button'
            onClick={handleForgotPassword}
            className='relative text-caption-500 tracking-[-0.28px] text-eggplant-500'>
            Forgot password
            <HandDrawnUnderline className='absolute bottom-0 left-0 h-1 w-full' />
          </button>
        </div>
        {resetSentTo ? <ResetSentCard email={resetSentTo} /> : null}
      </fieldset>
    </form>
  );
};
